import { GridContainer, GridItem } from '@xing-com/grid';

import { Styled } from './styles';

const ArticlesPageWrapper: React.FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  return (
    <GridContainer variant="FullSize">
      <GridItem span={12}>
        <Styled.ArticlesPageWrapper>{children}</Styled.ArticlesPageWrapper>
      </GridItem>
    </GridContainer>
  );
};

export default ArticlesPageWrapper;
